import { findByIdFromIdsCollectionFn, everyForImmutableCollectionFn } from '@Utils';

const everySelectedFn = everyForImmutableCollectionFn('selected');

function createFnSetSelectedAs(val) {
  return function mapSetSelectedAs(item) {
    return item.set('selected', val);
  };
}

export function selectThesaurusRootGroup(state, pathToFilter, pathToItems) {
  const selected = !state.getIn([...pathToFilter, 'selected']);

  return state.setIn([...pathToFilter, 'selected'], selected).updateIn(pathToItems, (items) => items.map(createFnSetSelectedAs(selected)));
}

export function updateSelectedValueInGroup(groupId, selected) {
  return function update(items) {
    return items.map((item) => {
      const itemRootIds = item.get('rootIds');
      const groupIdIsOneOfTheRootOfItem = itemRootIds.find(findByIdFromIdsCollectionFn(groupId));

      if (!groupIdIsOneOfTheRootOfItem) {
        return item;
      }

      return item.set('selected', selected);
    });
  };
}

export function updateSelectedValueInRootsOfGroup(rootIds) {
  return function update(items) {
    return (
      rootIds
        .reverse()
        .pop()
        .map((id) => items.getIn([id, 'id']))
        // eslint-disable-next-line no-shadow
        .reduce((items, rootId) => {
          const selected = items.filter((item) => item.get('rootIds').last() === rootId).every(everySelectedFn);

          return items.setIn([rootId, 'selected'], selected);
        }, items)
    );
  };
}

export function updateSelectedValueInTheRoot(filter) {
  const selected = filter
    .getIn(['thesaurusGroups', 'items'])
    .filter((item) => item.get('rootIds').count() === 1)
    .every(everySelectedFn);

  return filter.set('selected', selected);
}

export default function selectThesaurusGroupByIdHandler(state, action) {
  const { key, filterId, groupId } = action.payload;
  const pathToFilter = [key, 'items', filterId];
  const pathToItems = [...pathToFilter, 'thesaurusGroups', 'items'];
  const pathToGroup = [...pathToItems, groupId];
  const rootIds = state.getIn([...pathToGroup, 'rootIds']);

  if (!rootIds) {
    return selectThesaurusRootGroup(state, pathToFilter, pathToItems);
  }

  const selected = !state.getIn([...pathToGroup, 'selected']);

  return state
    .setIn([...pathToGroup, 'selected'], selected)
    .updateIn(pathToItems, updateSelectedValueInGroup(groupId, selected))
    .updateIn(pathToItems, updateSelectedValueInRootsOfGroup(rootIds))
    .updateIn(pathToFilter, updateSelectedValueInTheRoot);
}
